






















































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import CardTile from '@/views/browse-and-go/components/CardTile.vue'
import { audienceLabel, formatDuration } from '@/services/browse-and-go/labels'
import { bngState, deleteOperation } from '@/services/browse-and-go/store'

@Component({
  name: 'BrowseAndGoOtherOperations',
  components: { PageHeader, CardTile }
})
export default class extends Vue {
  private audienceLabel = audienceLabel
  private formatDuration = formatDuration

  get operations() {
    return bngState.operations.filter(operation => operation.family === 'OTHER')
  }

  private cardsOf(operationId: string) {
    return bngState.cards.filter(card => card.operationModelId === operationId)
  }

  mounted() {
    this.scrollToHash()
  }

  @Watch('$route.hash')
  private scrollToHash() {
    const id = (this.$route.hash || '').replace('#', '')
    if (!id) return
    this.$nextTick(() => {
      const element = document.getElementById(id)
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }

  private editOperation(id: string) {
    this.$router.push({ name: 'BrowseAndGoOtherOperationEdit', params: { id } })
  }

  private createCard(operationId: string) {
    this.$router.push({
      name: 'BrowseAndGoCardCreate',
      query: { operationId, from: 'other' }
    })
  }

  private editCard(id: string) {
    this.$router.push({ name: 'BrowseAndGoCardEdit', params: { id }, query: { from: 'other' } })
  }

  private cloneCard(id: string) {
    this.$router.push({ name: 'BrowseAndGoCardCreate', query: { cloneFrom: id, from: 'other' } })
  }

  private removeOperation(id: string) {
    this.$confirm(
      'Supprimer ce modèle d\'opération et ses modèles de carte multi-choix ?',
      'Supprimer',
      { type: 'warning', confirmButtonText: 'Supprimer', cancelButtonText: 'Annuler' }
    ).then(() => {
      deleteOperation(id)
      this.$message.success('Modèle d\'opération supprimé')
    }).catch(() => undefined)
  }
}
